export default __webpack_public_path__ + "static/media/logo-toro-.23f5ee45.png";